import React from "react";

const CareGivers = () => {
  return (
    <>
      <div className="flex text-center flex-col justify-center items-center py-28 gap-10 HeroBg2">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-blue-700 lg:mx-12 ">
          Together we thrive: partnering for success
        </h1>
        <p className="md:text-xl text-base  px-5 lg:px-[14%] text-justify">
          At ELiNA, our goal is to create an inclusive, supportive, and thriving
          school environment where every child can succeed. The SAIL and CoMPASS
          Programs are essential components in this journey, providing crucial
          insights into the factors affecting student performance and ensuring
          continuous support. By empowering educators, nurturing students, and
          fostering collaboration, we help schools become a beacon of support
          for children with special needs. Join us in making a difference and
          ensuring that every child has the opportunity to reach their full
          potential.
        </p>
        <p className="md:text-base text-sm px-5 lg:px-[18%]   font-bold ">
          Contact us today to learn more about how we can support your school
          community.
        </p>
        <a href="/#/school-form">
          <button className=" bg-pink-600 border-pink-600 lg:text-2xl text-white hover:bg-transparent hover:border-pink-600 hover:text-pink-600 py-2 px-4 rounded-full">
            Learn more and register
          </button>
        </a>
      </div>
    </>
  );
};

export default CareGivers;
